/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import {
  Heading,
  Button,
  TextField,
  DialogTrigger,
  Dialog,
  ActionButton,
  Content,
  Form,
  Flex,
  Item,
  Text,
  MenuTrigger,
  Menu,
  ProgressCircle,
  DialogContainer,
  AlertDialog,
  Link,
  Image,
} from '@adobe/react-spectrum';
import Share from '@spectrum-icons/workflow/Share';
import Rename from '@spectrum-icons/workflow/Rename';
import More from '@spectrum-icons/workflow/More';
import DeleteOutline from '@spectrum-icons/workflow/DeleteOutline';
import OpenInLight from '@spectrum-icons/workflow/OpenInLight';
import Remove from '@spectrum-icons/workflow/Remove';
import BookmarkSingle from '@spectrum-icons/workflow/BookmarkSingle';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { FlexContainer, Avatar } from './styles';
import actionWebInvoke from '../../utils/actionCallUtils';
import getHeaders from '../../utils/headers';
import actions from '../../config.json';
import RenameDialog from './RenameDialog';

const ProjectBoard = props => {
  const [state, setState] = useState({
    loading: false,
    currentText: '',
  });
  const [imageState, setImageState] = useState({
    loading: false,
  });

  const [boardLength, setBoardLength] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState();
  const [currentBoardName, setcurrentBoardName] = useState();
  const [projectBoard, setProjectBoard] = useState(false);
  const [boardTitle, setBoardTitle] = useState();
  const [imageDetail, setImageDetail] = useState({
    name: '',
    url: '',
    id: '',
  });

  const { ims } = props;
  const userID = ims.profile.userId;

  async function createUserBoards(boardname) {
    const setBoard = true;
    console.log('board name is', boardname);
    const headers = getHeaders(ims);
    await actionWebInvoke(actions['bookmark-action'], headers, {
      setBoard,
      userID,
      boardname,
    });
  }

  async function renameUserBoards(newBoardName, oldBoardName) {
    const renameBoard = true;
    const headers = getHeaders(ims);
    const response = await actionWebInvoke(
      actions['bookmark-action'],
      headers,
      {
        renameBoard,
        userID,
        newBoardName,
        oldBoardName,
      },
    );
    setState({ ...state, boards: response });
  }

  async function getUserBoards() {
    const getBoard = true;
    setLoading(true);
    const headers = getHeaders(ims);
    const response = await actionWebInvoke(
      actions['bookmark-action'],
      headers,
      {
        userID,
        getBoard,
      },
    );
    if (response) {
      setLoading(false);
    }
    setState({ ...state, boards: response });
  }

  async function getImagesOfBoards(board) {
    console.log('board name is ', { board });
    const getImage = true;
    const headers = getHeaders(ims);
    setProjectBoard(true);
    setLoading(true);
    const response = await actionWebInvoke(
      actions['bookmark-action'],
      headers,
      {
        getImage,
        userID,
        board,
      },
    );
    if (response) {
      setImageState({ ...imageState, images: response });
      setBoardTitle(board);
      setLoading(false);
    }
  }

  async function getAllBoardImages() {
    const getBoardsLength = true;
    const headers = getHeaders(ims);
    const response = await actionWebInvoke(
      actions['bookmark-action'],
      headers,
      {
        getBoardsLength,
        userID,
      },
    );
    setBoardLength(response);
  }

  async function deleteBoards(boardname) {
    const deleteBoard = true;
    const headers = getHeaders(ims);
    await actionWebInvoke(actions['bookmark-action'], headers, {
      deleteBoard,
      userID,
      boardname,
    });
  }

  async function deleteImages(imageURL, imageID, imageName, board) {
    const deleteImage = true;
    const headers = getHeaders(ims);
    await actionWebInvoke(actions['bookmark-action'], headers, {
      deleteImage,
      userID,
      imageURL,
      imageID,
      imageName,
      board,
    });
    getImagesOfBoards(board);
    getAllBoardImages();
  }

  useEffect(() => {
    getUserBoards();
    getAllBoardImages();
  }, [ims]);

  const setCurrentText = text => {
    setState({ ...state, currentText: text });
  };

  return projectBoard ? (
    <FlexContainer>
      <div className="flexContainer">
        <div className="titleBar">
          <span className="myBoards">{boardTitle}</span>
          <Button
            UNSAFE_className="AddBoard"
            variant="primary"
            onPress={() => setProjectBoard(false)}
          >
            Back
          </Button>
        </div>
        <div className="parentGrid">
          {loading ? (
            <Flex justifyContent="center">
              <ProgressCircle
                aria-label="Loading…"
                marginX="size-6000"
                marginY="size-3000"
                size="L"
                isIndeterminate
              />
            </Flex>
          ) : imageState?.images?.length > 0 ? (
            imageState?.images?.map((image, index) => {
              return (
                <div className="childBox" key={image + index}>
                  <div className="upperBoxImage">
                    <Image
                      src={image.url}
                      alt={image.name}
                      height="100%"
                      width="273px"
                    />
                    <div>
                      {image.id.match(/stock/g) ? (
                        <Avatar>St</Avatar>
                      ) : image.id.match(/adobeaemcloud/g) ? (
                        <Avatar>Ae</Avatar>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <div className="lowerBox">
                    <div>
                      <Tooltip title={image.name} arrow placement="right-start">
                        <span className="boardName">
                          {image.name.slice(0, 20)}
                          {image.name.length > 20 ? '...' : ''}
                        </span>
                      </Tooltip>
                      <>
                        <MenuTrigger>
                          <ActionButton isQuiet UNSAFE_className="action-btn">
                            <More />
                          </ActionButton>
                          <Menu
                            onAction={key => {
                              setDialog(key);
                              setcurrentBoardName(image.name);
                              setImageDetail({
                                name: image.name,
                                id: image.id,
                                url: image.url,
                              });
                            }}
                          >
                            <Item key="share" textValue="share">
                              <Share size="XS" />
                              <Text UNSAFE_className="menuText">
                                Share bookmark
                              </Text>
                            </Item>
                            <Item key="browser" textValue="browser">
                              <OpenInLight size="XXS" />
                              <Text UNSAFE_className="menuText">
                                <Link variant="secondary" isQuiet>
                                  <a
                                    href={`${image.id}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Open in browser
                                  </a>
                                </Link>
                              </Text>
                            </Item>
                            <Item key="delete" textValue="delete">
                              <Remove size="XXS" />
                              <Text UNSAFE_className="menuText">
                                Remove from borad
                              </Text>
                            </Item>
                          </Menu>
                        </MenuTrigger>
                        <DialogContainer onDismiss={() => setDialog(null)}>
                          {dialog === 'delete' && (
                            <AlertDialog
                              title="Delete"
                              variant="destructive"
                              primaryActionLabel="Delete"
                              onPrimaryAction={() =>
                                deleteImages(
                                  imageDetail.url,
                                  imageDetail.id,
                                  imageDetail.name,
                                  boardTitle,
                                )
                              }
                              secondaryActionLabel="cancel"
                            >
                              <Heading>Image is deleted</Heading>
                            </AlertDialog>
                          )}
                        </DialogContainer>
                      </>
                    </div>
                    <div>
                      <span className="description">description</span>
                      <span className="bookmark">
                        <BookmarkSingle size="XS" />
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <Heading marginStart="10px">No images bookmarked</Heading>
          )}
        </div>
      </div>
    </FlexContainer>
  ) : (
    <FlexContainer>
      <div className="flexContainer">
        <div className="titleBar">
          <span className="myBoards">My Boards</span>
          <DialogTrigger type="modal" isDismissable>
            <Button UNSAFE_className="AddBoard" variant="primary">
              Add board
            </Button>
            {closeMe => (
              <Dialog>
                <Heading>Create New Board</Heading>
                <Content>
                  <Form>
                    <Flex gap="size-150" wrap>
                      <TextField
                        width="size-5000"
                        aria-label="textfield"
                        placeholder="Board Name"
                        onChange={setCurrentText}
                      />
                      <Button
                        href="#/search"
                        UNSAFE_className="dropdown-item"
                        onPress={() => {
                          createUserBoards(state.currentText);
                          closeMe();
                        }}
                      >
                        Create Board
                      </Button>
                    </Flex>
                  </Form>
                </Content>
              </Dialog>
            )}
          </DialogTrigger>
        </div>
        <div className="parentGrid">
          {loading ? (
            <ProgressCircle
              aria-label="Loading…"
              marginX="size-6000"
              marginY="size-3000"
              size="L"
              isIndeterminate={loading}
            />
          ) : state && state.boards?.length > 0 ? (
            state.boards.map((boardName, index) => {
              return (
                <div className="childBox" key={boardName + index}>
                  <div>
                    <ActionButton
                      isQuiet
                      UNSAFE_className="upperBox"
                      onClick={() => {
                        getImagesOfBoards(boardName);
                      }}
                    />
                  </div>
                  <div className="lowerBox">
                    <div>
                      <span className="boardName">{boardName}</span>
                      <>
                        <MenuTrigger>
                          <ActionButton isQuiet UNSAFE_className="action-btn">
                            <More />
                          </ActionButton>
                          <Menu
                            onAction={key => {
                              setDialog(key);
                              setcurrentBoardName(boardName);
                            }}
                          >
                            <Item key="share" textValue="share">
                              <Share size="XS" />
                              <Text UNSAFE_className="menuText">
                                Share board
                              </Text>
                            </Item>
                            <Item key="rename" textValue="rename">
                              <Rename size="XS" />
                              <Text UNSAFE_className="menuText">Rename</Text>
                            </Item>
                            <Item key="delete" textValue="delete">
                              <DeleteOutline size="XS" />
                              <Text UNSAFE_className="menuText">Delete</Text>
                            </Item>
                          </Menu>
                        </MenuTrigger>
                        <DialogContainer onDismiss={() => setDialog(null)}>
                          {dialog === 'rename' && (
                            <RenameDialog
                              boardName={currentBoardName}
                              setCurrentText={setCurrentText}
                              renameUserBoards={renameUserBoards}
                              state={state}
                            />
                          )}
                          {dialog === 'delete' && (
                            <AlertDialog
                              title="Delete"
                              variant="destructive"
                              primaryActionLabel="Delete"
                              onPrimaryAction={() =>
                                deleteBoards(currentBoardName)
                              }
                              secondaryActionLabel="cancel"
                            >
                              Are you sure you want to delete this item?
                            </AlertDialog>
                          )}
                        </DialogContainer>
                      </>
                    </div>
                    <div>
                      <span className="description">description</span>
                      <span className="items">
                        {boardLength &&
                          boardLength.length &&
                          `${
                            boardLength[index] !== null ? boardLength[index] : 0
                          } items`}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <Heading marginStart="10px">No results</Heading>
          )}
          {}
        </div>
      </div>
    </FlexContainer>
  );
};

ProjectBoard.propTypes = {
  ims: PropTypes.shape({
    org: PropTypes.string,
    token: PropTypes.string,
    profile: PropTypes.shape({
      userId: PropTypes.string,
    }),
  }).isRequired,
};

export default ProjectBoard;
